import { getBackgroundImage } from "../../helpers";
import { buildBaseballLiveMobileProps } from "../buildBaseballLiveMobileProps";
export const buildBaseballLiveDesktopProps = (event, config) => {
    return Object.assign(Object.assign({}, buildBaseballLiveMobileProps(event, config)), { backgroundImage: getBackgroundImage(event, config.cmsConfig.backgroundImages) });
};
//# sourceMappingURL=buildBaseballLiveDesktopProps.js.map